import React from "react";
import { BsCaretLeft, BsCaretRight } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { SlOptionsVertical } from "react-icons/sl";

type ViewImageProps = {
  feedImages: string[];
  currentIndex: number;
  handlePrev: () => void;
  handleNext: () => void;
  totalImages: number;
  handleClick: () => void;
};
const ViewImage: React.FC<ViewImageProps> = ({
  feedImages,
  currentIndex,
  handlePrev,
  handleNext,
  totalImages,
  handleClick,
}) => {
  const [openDownload, setOpenDownload] = React.useState(false);
  const handleDownload = async () => {
    try {
      const url = ipfsGatewayImage(feedImages[currentIndex]);
      const response = await fetch(url);
      const blob = await response.blob();
      console.log(blob);

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", "downloaded-image.jpg");
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      link.remove();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="picModal bg-black fixed inset-0 py-10 z-30 justify-center overflow-y-hidden items-center flex">
      <div className="flex bg-comPagBg h-10 w-10  rounded-full active:bg-bgGrey fixed top-1 right-2 items-center justify-center">
        <button className="cursor-pointer items-center justify-center flex">
          <SlOptionsVertical
            // className="text-white"
            onClick={() => setOpenDownload(!openDownload)}
          />
        </button>
      </div>
      {openDownload && (
        <div
          className="flex bg-white h-10 font-Poppins fixed top-12 cursor-pointer right-10 items-center justify-center p-2 font-semibold"
          onClick={handleDownload}
        >
          Download
        </div>
      )}
      <div className="p-4 flex items-center justify-center">
        <img
          src={ipfsGatewayImage(feedImages[currentIndex])}
          alt=""
          className=" w-auto max-w-lg h-auto max-h-[90%]"
        />
      </div>
      <div className="flex gap-3 fixed top-1 left-1 items-center justify-center">
        <button className="cursor-pointer h-10 w-10 items-center justify-center flex rounded-full">
          <IoMdClose
            size={33}
            className="cursor-pointer text-white"
            onClick={handleClick}
          />
        </button>
        <img src="/logo.png" alt="" className="w-10 h-10" />
      </div>

      {feedImages.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="fixed top-[50%] cursor-pointer left-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey"
          >
            <BsCaretLeft size={35} className="cursor-pointer" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === totalImages - 1}
            className="fixed top-[50%]  cursor-pointer right-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey "
          >
            <BsCaretRight size={35} className="cursor-pointer" />
          </button>
        </>
      )}
    </div>
  );
};

export default ViewImage;
